<template>
  <div class="inbox container">
    <div class="row mb-45">
      <div class="col-12 col-md-6">
        <h1>Messages</h1>
      </div>
      <div class="col-12 col-md-6 text-right" v-if="false">
        <b-button-group>
          <b-button class="active"> Inbox </b-button>
          <!-- <b-button>Drafts</b-button> -->
          <b-button class="last">Outbox</b-button>
          <!-- <b-button class="last">
            Deleted
          </b-button> -->
        </b-button-group>
      </div>
    </div>

    <div class="row" v-if="!messageThreads">
      <Loader style="width: 100%" />
    </div>

    <div class="row" v-else-if="messageThreads.length === 0">
      <div class="col-12">
        <div class="no-results" style="margin-top: 0">
          <h3>No Messages</h3>
          <p>
            You haven't sent or received any messages yet. When you do, they'll
            appear here.
          </p>
        </div>
      </div>
    </div>

    <div class="row" v-else>
      <div class="col-12 col-lg-4">
        <div class="message-list">
          <ul>
            <li
              v-for="thread in messageThreads"
              :key="thread.id"
              :class="{
                active: selectedThread && selectedThread.id === thread.id
              }"
              class="pointer-cursor"
              role="button"
              @click="selectThread(thread)"
            >
              <div class="row upper">
                <div class="col-8">
                  <div class="viewing">VIEWING</div>
                  <span>{{
                    thread.otherUserName($store.getters.currentUser.id)
                  }}</span>
                  <!-- <span>{{thread.senderDisplay}}</span> -->
                </div>
                <div class="col-4 text-right">
                  {{ thread.latest_message.timestamp | shortDateNoYear }}
                  <span class="new-indicator" v-if="thread.has_unread">
                    NEW MESSAGES
                  </span>
                  <!-- <span>{{thread.recipientDisplay}}</span> -->
                </div>
              </div>
              <p>
                {{ thread.latest_message.message }}
              </p>
            </li>
          </ul>
        </div>
        <div class="inbox-pagination">
          <div class="left">
            <button
              class="prev"
              type="button"
              :disabled="page <= 0 || maxPage <= 1"
              @click="pageBack()"
            >
              <span class="sr-only">{{
                page === 0 ? 'Disabled, No Previous Page' : 'Previous Page'
              }}</span>
              <font-awesome-icon
                :icon="['fas', 'caret-left']"
                class="icon alt"
              />
            </button>
          </div>
          <div class="mid">Page {{ page }} of {{ maxPage }}</div>
          <div class="right">
            <button
              class="next"
              type="button"
              :disabled="page >= maxPage"
              @click="pageNext()"
            >
              <span class="sr-only">{{
                page === maxPage ? 'Disabled, On Last Page' : 'Next Page'
              }}</span>
              <font-awesome-icon
                :icon="['fas', 'caret-right']"
                class="icon alt"
              />
            </button>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-8 d-none d-lg-block">
        <Loader v-if="!messages" style="width: 100%" />

        <p v-else-if="messages.length === 0">There are no messages yet.</p>
        <message-thread v-else :messages="messages" :reply="reply" />
      </div>
    </div>

    <!--Send Message Modal-->
    <view-message-modal
      ref="viewMessageModal"
      :messages="messages"
      :reply="reply"
    />
    <send-message-modal ref="sendMessageModal" />
    <!-- <delete-message-modal /> -->
  </div>
</template>

<script>
import MessageThread from '@/components/MessageThread.vue';
import SendMessageModal from '@/components/modals/SendMessageModal.vue';
import ViewMessageModal from '@/components/modals/ViewMessageModal.vue';
import UserClient from '@/api/UserClient';
import Loader from '@/components/Loader';

export default {
  name: 'Inbox',
  components: {
    MessageThread,
    SendMessageModal,
    ViewMessageModal,
    Loader
  },
  data() {
    return {
      userClient: new UserClient(this.$http),
      messageThreads: null,
      selectedThread: null,

      messages: null,

      count: 0,
      page: 1,
      limit: 10
    };
  },
  computed: {
    maxPage() {
      return Math.ceil(this.count / this.limit);
    }
  },
  mounted() {
    this.loadMessageThreads();
  },

  methods: {
    selectThread(thread, supressMobile = false) {
      window.scrollTo(0, 0);
      this.messages = null;
      this.selectedThread = thread;

      // for mobile we need to open the modal
      if (!supressMobile && this.$globals.isMobile) {
        this.$refs.viewMessageModal.show(this.selectedThread);
      }

      this.userClient
        .getMessages(this.selectedThread.id)
        .then((response) => {
          this.messages = response.results || [];
        })
        .catch((ex) => {
          this.messages = [];
        });

      this.userClient.markAsRead(this.selectedThread.id);
      this.selectedThread.has_unread = false;
    },
    loadMessageThreads() {
      const offset = (this.page - 1) * this.limit;

      this.userClient
        .getMessageThreads(this.limit, offset)
        .then((response) => {
          this.messageThreads = response.results || [];
          this.count = response.count;

          if (this.messageThreads.length) {
            this.selectThread(this.messageThreads[0], true);
          }
        })
        .catch((ex) => {
          this.messageThreads = [];
          this.count = 0;
        });
    },
    onPageChanged(page) {
      if (page !== this.page) {
        this.page = page;

        if (this.page < 0) {
          this.page = 0;
        }

        if (this.page > this.maxPage) {
          this.page = this.maxPage;
        }

        this.loadMessageThreads();
      }
    },
    pageBack() {
      this.onPageChanged(this.page - 1);
    },
    pageNext() {
      this.onPageChanged(this.page + 1);
    },

    reply(message, user_id) {
      this.$refs.viewMessageModal.hide();
      this.$refs.sendMessageModal.show(user_id, message);
    }
  }
};
</script>

<style lang="scss" scoped>
.pointer-cursor {
  cursor: pointer;
}

.new-indicator {
  font-size: 8px;
  color: $red;
}

.inbox {
  ::v-deep .btn-group {
    margin-top: 8px;

    @media (max-width: $sm-max) {
      width: 100%;
    }

    .btn {
      @include border-radius($border-radius !important);

      background: rgba(255, 255, 255, 0.25) !important;
      color: white !important;
      margin-right: 5px;
      font-weight: normal;

      @media (min-width: $xl-min) {
        min-width: 120px;
      }

      &.last {
        margin-right: 0;
      }

      &.active {
        background-color: white !important;
        color: rgba(0, 0, 0, 0.76) !important;
      }

      @media (max-width: $sm-max) {
        width: 25%;
      }
    }
  }

  .message-list {
    @include border-radius($border-radius);

    background: $dark-blue;
    padding: 0;

    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;

      li {
        display: block;
        padding: 20px;
        border-bottom: solid 1px rgba(255, 255, 255, 0.15);
        opacity: 1;
        position: relative;

        &:hover {
          opacity: 1;
          background: #0c1e30;

          .upper span {
            text-decoration: underline;
          }
        }

        &:last-of-type {
          border-bottom: none;
        }

        .upper {
          font-weight: 500;
          font-size: 16px;
          letter-spacing: 0.03rem;
          margin-bottom: 1rem;

          span {
            display: block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-bottom: 0;
          font-size: 14px;
          color: rgba(white, 0.76);
        }

        .viewing {
          display: none;
        }

        &.active {
          opacity: 1;

          .viewing {
            display: block;
            font-size: 12px;
            color: lightgreen;
            font-weight: 400;
            letter-spacing: 0.03rem;

            svg {
              margin-right: 4px;
            }
          }
        }
      }
    }
  }

  .inbox-pagination {
    margin-top: 15px;

    .left,
    .right {
      width: 35px;
      display: inline-block;
      vertical-align: top;
    }

    .right {
      text-align: right;
    }

    .mid {
      display: inline-block;
      width: calc(100% - 70px);
      text-align: center;
      line-height: 47px;
    }

    button {
      background: none;
      border: none;
      color: white;
      font-size: 30px;
      width: 35px;

      &:hover:not(:disabled) {
        color: $green;
      }
    }

    button:disabled,
    button[disabled] {
      opacity: 0.3;
    }
  }

  .hidden-sm {
    @media (max-width: $sm-max) {
      display: none;
    }
  }
}
</style>
